// Core
import React from "react"
import styled from "styled-components"

// General components
import Title from "../../../../../../components/Title"
import Paragraph from "../../../../../../components/Paragraph"
import CTALink from "../../../../../../components/CTALink"

// Style
import size from "../../../../../../styles/size"

const Container = styled.div`
  width: 100%;
  margin-left: 12rem;
  margin-top: 2.3rem;

  p {
    margin-top: 3rem;
  }

  @media (max-width: ${size.laptop}) {
    margin-top: 6rem;
    margin-left: 0px;
  }
`

export default function FollowUsContainer() {
  return (
    <Container>
      <Title>Nos acompanhe ONLINE</Title>

      <Paragraph>
        Faça parte de nossas principais celebrações de qualquer lugar do mundo.
      </Paragraph>

      <Paragraph>
        Em tempo real ou quando você desejar, estaremos prontos para te servir
        em nosso canal.
      </Paragraph>

      <CTALink
        pictonBlueBG
        lightText
        rel="noopener"
        href="https://www.youtube.com/oceanodagraca/live"
        target="_blank"
      >
        ASSISTA AGORA
      </CTALink>
    </Container>
  )
}
